function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGcpLogo = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 512,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Cloud_logo",
    "data-name": "Google Cloud logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2899.66 512",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_1570x512px",
    "data-name": "1570x512px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1890.13,397.29q-77.91,0-130.34-52.43-51.94-52.42-51.94-130.83t51.94-130.34q51.93-52.92,130.34-52.92,79.38,0,128.87,57.33l-32.34,31.36q-37.74-45.57-96.53-45.57-58.32,0-97.51,39.2-38.71,38.72-38.71,100.94T1792.62,315q39.2,39.21,97.51,39.2,61.24,0,106.33-51.45l32.83,31.85a170.14,170.14,0,0,1-61.25,46.3A186.79,186.79,0,0,1,1890.13,397.29ZM2103.86,38.61V389.45h-45.08V38.61Zm32.58,230.79q0-55.36,34.79-91.63,35.28-36.26,88.69-36.26t88.2,36.26Q2383.4,214,2383.4,269.4q0,55.86-35.28,91.63-34.78,36.27-88.2,36.26T2171.23,361Q2136.44,324.78,2136.44,269.4Zm45.08,0q0,38.72,22.54,62.72t55.86,24q33.33,0,55.86-24t22.54-62.72q0-38.22-22.54-62.23-23-24.49-55.86-24.5t-55.86,24.5Q2181.53,231.19,2181.52,269.4ZM2626.3,389.45h-43.12V356.13h-2q-10.29,17.64-31.61,29.4a90.58,90.58,0,0,1-44.34,11.76q-44.1,0-67.87-25.24t-23.76-71.78V149.35h45.08v148q1.47,58.8,59.29,58.8,26.94,0,45.08-21.81t18.13-52.18V149.35h45.08Zm146.45,7.84q-47,0-80.85-37.24-33.33-37.73-33.32-90.65t33.32-90.65q33.81-37.23,80.85-37.24,26.46,0,48.27,11.27t33.56,29.89h2l-2-33.32V38.61h45.08V389.45h-43.12V356.13h-2Q2842.82,374.76,2821,386T2772.75,397.29Zm7.35-41.16q33.32,0,54.39-24,22.05-24,22.05-62.72,0-37.72-22.05-62.23-21.55-24.49-54.39-24.5-32.34,0-54.39,24.5t-22.05,62.23q0,38.22,22.05,62.23Q2747.76,356.14,2780.1,356.13Z",
    transform: "translate(0)",
    style: {
      fill: "#5f6368"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,235.58V181.32H384a178.07,178.07,0,0,1,2.94,33.27c0,40.68-11.14,91.06-47,126.9-34.86,36.33-79.42,55.71-138.5,55.71C92,397.2,0,308.07,0,198.6S92,0,201.45,0C262,0,305.09,23.74,337.53,54.74L299.27,93C276,71.21,244.55,54.25,201.45,54.25c-79.9,0-142.37,64.42-142.37,144.35S121.55,343,201.45,343c51.82,0,81.36-20.83,100.24-39.72,15.39-15.39,25.53-37.47,29.46-67.65Z",
    transform: "translate(0)",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.64,269.32C663.64,343,606,397.2,535.32,397.2S407,343,407,269.32c0-74.11,57.63-127.88,128.34-127.88S663.64,195.21,663.64,269.32Zm-56.17,0c0-46-33.41-77.5-72.15-77.5s-72.16,31.48-72.16,77.5c0,45.53,33.41,77.5,72.16,77.5S607.47,314.85,607.47,269.32Z",
    transform: "translate(0)",
    style: {
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.59,269.32C943.59,343,886,397.2,815.27,397.2S686.94,343,686.94,269.32c0-74.11,57.62-127.88,128.33-127.88S943.59,195.21,943.59,269.32Zm-56.17,0c0-46-33.41-77.5-72.15-77.5s-72.16,31.48-72.16,77.5c0,45.53,33.41,77.5,72.16,77.5S887.42,314.85,887.42,269.32Z",
    transform: "translate(0)",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.93,149.19v229.6c0,94.46-55.69,133.21-121.55,133.21-62,0-99.28-41.66-113.32-75.56L1026,416.09c8.71,20.83,30,45.53,64.41,45.53,42.13,0,68.28-26.16,68.28-75.08v-18.4h-1.94c-12.59,15.5-36.8,29.06-67.31,29.06-63.93,0-122.52-55.71-122.52-127.39,0-72.18,58.59-128.37,122.52-128.37,30.51,0,54.72,13.56,67.31,28.58h1.94V149.19Zm-49.4,120.62c0-45.05-30-78-68.28-78-38.74,0-71.19,32.94-71.19,78,0,44.56,32.45,77,71.19,77C1132.51,346.82,1162.53,314.37,1162.53,269.81Z",
    transform: "translate(0)",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.07,14.82V389.45H1250.9V14.82Z",
    transform: "translate(0)",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524,311.46l43.58,29.07c-14,20.82-47.94,56.67-106.54,56.67-72.64,0-126.88-56.19-126.88-127.88,0-76,54.73-127.88,120.58-127.88,66.35,0,98.79,52.8,109.45,81.38l5.81,14.53-171,70.72c13.08,25.67,33.42,38.75,62,38.75S1509.47,332.78,1524,311.46Zm-134.15-46L1504.14,218c-6.3-16-25.18-27.12-47.46-27.12C1428.11,190.85,1388.4,216,1389.85,265.45Z",
    transform: "translate(0)",
    style: {
      fill: "#ea4335"
    }
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 512,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Cloud_logo",
    "data-name": "Google Cloud logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2899.66 512",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_1570x512px",
    "data-name": "1570x512px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1890.13,397.29q-77.91,0-130.34-52.43-51.94-52.42-51.94-130.83t51.94-130.34q51.93-52.92,130.34-52.92,79.38,0,128.87,57.33l-32.34,31.36q-37.74-45.57-96.53-45.57-58.32,0-97.51,39.2-38.71,38.72-38.71,100.94T1792.62,315q39.2,39.21,97.51,39.2,61.24,0,106.33-51.45l32.83,31.85a170.14,170.14,0,0,1-61.25,46.3A186.79,186.79,0,0,1,1890.13,397.29ZM2103.86,38.61V389.45h-45.08V38.61Zm32.58,230.79q0-55.36,34.79-91.63,35.28-36.26,88.69-36.26t88.2,36.26Q2383.4,214,2383.4,269.4q0,55.86-35.28,91.63-34.78,36.27-88.2,36.26T2171.23,361Q2136.44,324.78,2136.44,269.4Zm45.08,0q0,38.72,22.54,62.72t55.86,24q33.33,0,55.86-24t22.54-62.72q0-38.22-22.54-62.23-23-24.49-55.86-24.5t-55.86,24.5Q2181.53,231.19,2181.52,269.4ZM2626.3,389.45h-43.12V356.13h-2q-10.29,17.64-31.61,29.4a90.58,90.58,0,0,1-44.34,11.76q-44.1,0-67.87-25.24t-23.76-71.78V149.35h45.08v148q1.47,58.8,59.29,58.8,26.94,0,45.08-21.81t18.13-52.18V149.35h45.08Zm146.45,7.84q-47,0-80.85-37.24-33.33-37.73-33.32-90.65t33.32-90.65q33.81-37.23,80.85-37.24,26.46,0,48.27,11.27t33.56,29.89h2l-2-33.32V38.61h45.08V389.45h-43.12V356.13h-2Q2842.82,374.76,2821,386T2772.75,397.29Zm7.35-41.16q33.32,0,54.39-24,22.05-24,22.05-62.72,0-37.72-22.05-62.23-21.55-24.49-54.39-24.5-32.34,0-54.39,24.5t-22.05,62.23q0,38.22,22.05,62.23Q2747.76,356.14,2780.1,356.13Z",
    transform: "translate(0)",
    style: {
      fill: "#5f6368"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,235.58V181.32H384a178.07,178.07,0,0,1,2.94,33.27c0,40.68-11.14,91.06-47,126.9-34.86,36.33-79.42,55.71-138.5,55.71C92,397.2,0,308.07,0,198.6S92,0,201.45,0C262,0,305.09,23.74,337.53,54.74L299.27,93C276,71.21,244.55,54.25,201.45,54.25c-79.9,0-142.37,64.42-142.37,144.35S121.55,343,201.45,343c51.82,0,81.36-20.83,100.24-39.72,15.39-15.39,25.53-37.47,29.46-67.65Z",
    transform: "translate(0)",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.64,269.32C663.64,343,606,397.2,535.32,397.2S407,343,407,269.32c0-74.11,57.63-127.88,128.34-127.88S663.64,195.21,663.64,269.32Zm-56.17,0c0-46-33.41-77.5-72.15-77.5s-72.16,31.48-72.16,77.5c0,45.53,33.41,77.5,72.16,77.5S607.47,314.85,607.47,269.32Z",
    transform: "translate(0)",
    style: {
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.59,269.32C943.59,343,886,397.2,815.27,397.2S686.94,343,686.94,269.32c0-74.11,57.62-127.88,128.33-127.88S943.59,195.21,943.59,269.32Zm-56.17,0c0-46-33.41-77.5-72.15-77.5s-72.16,31.48-72.16,77.5c0,45.53,33.41,77.5,72.16,77.5S887.42,314.85,887.42,269.32Z",
    transform: "translate(0)",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.93,149.19v229.6c0,94.46-55.69,133.21-121.55,133.21-62,0-99.28-41.66-113.32-75.56L1026,416.09c8.71,20.83,30,45.53,64.41,45.53,42.13,0,68.28-26.16,68.28-75.08v-18.4h-1.94c-12.59,15.5-36.8,29.06-67.31,29.06-63.93,0-122.52-55.71-122.52-127.39,0-72.18,58.59-128.37,122.52-128.37,30.51,0,54.72,13.56,67.31,28.58h1.94V149.19Zm-49.4,120.62c0-45.05-30-78-68.28-78-38.74,0-71.19,32.94-71.19,78,0,44.56,32.45,77,71.19,77C1132.51,346.82,1162.53,314.37,1162.53,269.81Z",
    transform: "translate(0)",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.07,14.82V389.45H1250.9V14.82Z",
    transform: "translate(0)",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524,311.46l43.58,29.07c-14,20.82-47.94,56.67-106.54,56.67-72.64,0-126.88-56.19-126.88-127.88,0-76,54.73-127.88,120.58-127.88,66.35,0,98.79,52.8,109.45,81.38l5.81,14.53-171,70.72c13.08,25.67,33.42,38.75,62,38.75S1509.47,332.78,1524,311.46Zm-134.15-46L1504.14,218c-6.3-16-25.18-27.12-47.46-27.12C1428.11,190.85,1388.4,216,1389.85,265.45Z",
    transform: "translate(0)",
    style: {
      fill: "#ea4335"
    }
  })));
});
export default SvgIconGcpLogo;
export const raw = __webpack_public_path__ + "static/media/icon-gcp-logo.2a79664b409c8ea8fa9a5c26f46422da.svg";